import { render } from "./SensorReportingItem.vue?vue&type=template&id=dc89e376"
import script from "./SensorReportingItem.vue?vue&type=script&lang=js"
export * from "./SensorReportingItem.vue?vue&type=script&lang=js"

import "./SensorReportingItem.vue?vue&type=style&index=0&id=dc89e376&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__